// @core/api/endpoints/team/update_team_security_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamSecuritySettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team security settings
 * Updates an existing team security settings with the provided data. Returns the updated resource.
 */
export async function UpdateTeamSecuritySettings(
  team_id: string,
  data: UpdateTeamSecuritySettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/security`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
